export default __webpack_public_path__ + "static/media/logo-loading-animated-black.b470ed99.svg";